export const companyInfo = {
  name: 'Omega Metal Industries',
  abbrev: 'OMSC',
  tagline: 'Offering a Variety of High-Quality Products & Services',
  description: 'A Leading Industrial Fabrication & Machining Company, Serving Since 1996',
  about: 'Omega Metal Industries (OMSC) is a leading industrial fabrication and machining company established in 1996, serving the oil & gas sector and related industries across Saudi Arabia and neighboring countries. With over 30 years of experience, we deliver precision-engineered components and fabrication solutions to more than 400 satisfied customers across 25,000+ completed projects.',
  founded: 1996,
  website: 'www.omegamet.com',

  contact: {
    phone: '+966567268615',
    phoneFormatted: '+966567268615',
    phoneDisplay: '+966 567 268 615',
    whatsapp: '+966567268615',
    whatsappLink: 'https://wa.me/966567268615',
    email: 'sales@omegamet.com',
    salesEmail: 'sales@omegamet.com',
    quoteEmail: 'sales@omegamet.com',
    emails: {
      sales: 'sales@omegamet.com',
      info: 'info@omegamet.com'
    },
    salesContact: {
      name: 'Usman Mehboob',
      position: 'Sales Executive',
      phone: '+966567268615',
      phoneFormatted: '+966567268615',
      email: 'usman@omegamet.com'
    }
  },

  address: {
    street: '8259 Adh Dhahran Al Jubail Expressway, Industrial Unit No. 2',
    city: 'Dammam',
    zip: '32443-3205',
    country: 'Kingdom of Saudi Arabia',
    full: '8259 Adh Dhahran Al Jubail Expressway, Industrial Unit No. 2, Dammam 32443-3205, Kingdom of Saudi Arabia'
  },

  hours: {
    formatted: [
      { days: 'Sat - Thu', hours: '7:00 AM - 6:00 PM' },
      { days: 'Friday', hours: 'Closed' }
    ]
  },

  social: {
    linkedin: 'https://linkedin.com/company/omega-met-services',
    facebook: 'https://facebook.com/omegametservices'
  },

  stats: [
    { value: '30+', label: 'Years Experience' },
    { value: '400+', label: 'Satisfied Customers' },
    { value: '25,000+', label: 'Projects Completed' },
    { value: '1996', label: 'Year Established' }
  ],

  values: [
    {
      title: 'Quality',
      description: 'Committed to delivering precision-engineered products that meet the highest industry standards, with rigorous quality control at every stage.'
    },
    {
      title: 'Expertise',
      description: 'Over 30 years of deep industry knowledge serving the oil & gas sector, with experienced engineers and skilled craftsmen on every project.'
    },
    {
      title: 'Innovation',
      description: 'Continuously investing in state-of-the-art equipment and advanced manufacturing techniques to stay at the forefront of industrial fabrication.'
    },
    {
      title: 'Ethical Responsibility',
      description: 'We conduct business with integrity, transparency, and sustainable practices, building long-term partnerships with our clients and community.'
    }
  ],

  whyChooseUs: [
    {
      icon: 'precision',
      title: 'Tight Tolerance Machining',
      description: 'CNC machining capabilities with tolerance accuracy of ±0.001" to ±0.005" for the most demanding oil & gas applications.'
    },
    {
      icon: 'certified',
      title: 'ISO 9001 Certified',
      description: 'Certified to ISO 9001 quality management system standard, ensuring consistent product quality and continuous improvement across all operations.'
    },
    {
      icon: 'experience',
      title: '30+ Years Experience',
      description: 'Serving the oil & gas sector since 1996, with over 400 customers and 25,000+ completed projects in Saudi Arabia and beyond.'
    },
    {
      icon: 'delivery',
      title: 'Oil & Gas Specialists',
      description: 'Primary focus on oil & gas industry components including valves, shafts, pipe fittings, and pressure equipment.'
    },
    {
      icon: 'support',
      title: 'Full Engineering Support',
      description: 'CAD/CAM design, reverse engineering, 2D/3D engineering design, and DFM analysis from our in-house engineering team.'
    },
    {
      icon: 'materials',
      title: 'Saudi Arabia & Region',
      description: 'Strategically located in Dammam, KSA, serving Saudi Arabia and neighboring countries with approved vendor status at major oil & gas companies.'
    }
  ]
}
